import { format } from "date-fns";
import { convertToLocalTime } from "date-fns-timezone";

export function getTimestampInLocalTime(timestamp, customFormat = "EEE dd/MM/yy h:mm:ss aaa") {
	try {
		const date = new Date(timestamp);
		const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		const dateFormat = customFormat ?? "EEE dd/MM/yy h:mm:ss aaa";
		if (timeZone) {
			const zonedDate = convertToLocalTime(date, { timeZone: timeZone });
			return format(zonedDate, dateFormat);
		} else {
			return format(date, dateFormat);
		}
	} catch {
		return timestamp;
	}
}

//Returns an array of times [12:00 AM, 01:00AM, ....., 12:00 PM ....]
export const getAmPmTimes = () => {
	const baseHours = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
	const format = (h, ampm) => {
		if (h > 9) return `${h}:00 ${ampm}`;
		else return `0${h}:00 ${ampm}`;
	};
	const am = baseHours.map((h) => format(h, "AM"));
	const pm = baseHours.map((h) => format(h, "PM"));

	return am.concat(pm);
};

// Returns current Houre of time ignoring minutes. For example if it is 10:59 AM it will return 10:00 AM
export const getCurrentTime = () => {
	const date = new Date();
	const hours = date.getHours();
	let pmHours = hours - 12;
	if (pmHours >= 0) {
		pmHours = pmHours === 0 ? 12 : pmHours;
		return pmHours < 10 ? `0${pmHours}:00 PM` : `${pmHours}:00 PM`;
	} else return hours < 10 ? `0${hours}:00 AM` : `${hours}:00 AM`;
};
